import axios from 'axios'
function defaultEmailValidationData() {
    return {
        emailsValidationError: false,
        validatedEmails: [],
        invalidEmailsList: [],
        emailValidatedWithPublicAPI: false,
        validatingEmails: false,
        emailValidationOutcomes: {
            HIGH_RISK_EMAIL: 'high',
            LOW_RISK_EMAIL: 'low',
            UNKNOWN_RISK_EMAIL: 'unknown',
            UNVALIDATED_EMAIL: 'N/A'
        },
        backendError: false,
        foundInvalidEmails: false,
        emailValidationErrorTypes: {
            EMAIL_VALIDATION_BACKEND_ERROR: 'backendError',
            INVALID_EMAILS_ERROR: 'invalidEmails'
        }
    }
}
export const emailValidation = {
    data() {
        return defaultEmailValidationData()
    },
    methods: {
        setEmailValidationDefaultData: function () {
            Object.assign(this.$data, defaultEmailValidationData())
        },
        validateEmails: function (emailArray) {
            this.setEmailValidationDefaultData()
            this.validatingEmails = true
            this.$store.dispatch('showSnackBar', {
                snackBarText: 'Validating emails, please wait....',
                snackBarTimeout: 1500,
                snackBarIcon: 'info'
            })
            const postBody = { email_list: emailArray }
            return this.$axios
                .post('/validate_email_address', postBody, { timeout: 300000 })
                .then(response => {
                    if (response.data) {
                        const emailList = []
                        response.data.forEach(email => {
                            if (email.risk === this.emailValidationOutcomes.UNVALIDATED_EMAIL) {
                                this.backendError = true
                            }
                            if (email.risk === this.emailValidationOutcomes.HIGH_RISK_EMAIL) {
                                this.invalidEmailsList.push({ email: email.address, status: email.risk })
                                this.foundInvalidEmails = true
                            }
                            emailList.push({ email: email.address, status: email.risk })
                        })
                        this.validatedEmails = emailList
                    }
                })
                .catch(() => {
                    this.emailsValidationError = true
                })
                .finally(() => {
                    this.validatingEmails = false
                })
        },
        validateEmailsWithPublicMailgunApi: function (email) {
            this.setEmailValidationDefaultData()
            this.validatingEmails = true
            return axios
                .get('https://api.mailgun.net/v3/address/validate', {
                    params: {
                        address: email,
                        api_key: 'pubkey-290426e66acbb1da0fc03a7bf19866cb'
                    }
                })
                .then(response => {
                    if (response.data && !response.data.is_valid) {
                        this.foundInvalidEmails = true
                        this.invalidEmailsList.push({ email })
                    } else if (response.data && response.data.is_valid) {
                        this.emailValidatedWithPublicAPI = true
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.emailsValidationError = true
                })
                .finally(() => {
                    this.validatingEmails = false
                })
        }
    }
}
